// extracted by css-extract-rspack-plugin
export default {"secondLevel":"second-level--vBrXUjpY_EiEKC9c","blokoSecondLevel":"bloko-second-level--JxfUC3Ggiy03ggrn"};